module.exports = __webpack_public_path__ + "img/ascend_gold8.43731576.png";